import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ArchiveIcon from '@mui/icons-material/Archive';

const DeleteConfirmModal = ({
  open,
  onClose,
  onConfirm,
  itemName,
  variant = 'delete',
}) => {
  const isArchive = variant === 'archive';
  const title = isArchive ? 'Confirm archive' : 'Confirm Delete';
  const ConfirmIcon = isArchive ? ArchiveIcon : DeleteIcon;
  const confirmLabel = isArchive ? 'Archive' : 'Delete';
  const confirmColor = isArchive ? 'warning' : 'error';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-dialog-description">
          {isArchive ? (
            <>
              Archive <strong>{itemName}</strong>? It will be removed from this
              register but not permanently deleted.
            </>
          ) : (
            <>
              Are you sure you want to delete <strong>{itemName}</strong>? This
              action cannot be undone.
            </>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color={confirmColor}
          variant="contained"
          startIcon={<ConfirmIcon />}
          autoFocus
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmModal;

